module.exports = __webpack_public_path__ + "static/media/spotifypodcast.a714c135.png";